import { Granularity as ApiGranularity } from "reedy-data/api";

// Mirror the API's `Granularity` enum values as a string union, so plain string
// literals ("weekly") and the generated enum members are interchangeable. Which
// granularities are available for a given window is decided by the backend and
// returned on the sales response -- the client never recomputes that matrix.
export type Granularity = `${ApiGranularity}`;

// Every granularity the API defines, in enum order (daily -> weekly -> monthly);
// drives the toggle's pill order so the option list can't drift from the backend.
export const GRANULARITIES: Granularity[] = Object.values(ApiGranularity);
